<template>
  <div class="w-full h-full flex flex-col">
    <!--   --------------------- hero------------------>
    <page-hero bg="contact-us" :title="page.title" :subtitle="page.sub_title">
      <template #title>
        <span class="text-primary1"> Nice</span> to see you here!
      </template>
      <template #subtitle>
        We can help you build an amazing digital product
      </template>
    </page-hero>
    <!--  ----------------------- contacts------------------------- -->
    <section class="pt-96p">
      <div class="flex justify-around flex-wrap gap-24 sm:gap-5">
        <contact-item v-for="contact in contacts" :key="contact.title" data-aos="fade-down" data-aos-duration="1000">
          <template #icon>
            <img :src="contact.icon" alt="">
          </template>

          <template #title>
            {{ contact.title }}
          </template>

          <a
            :href="contact.href"
            :target="contact.type === 'location' ? undefined : '_self'"
            class="underline text-18 text-navy"
          >{{ contact.info }}</a>

          <template #descrioption>
            {{ contact.description }}
          </template>
        </contact-item>
      </div>
    </section>

    <section-layout>
      <template #title>
        Get in touch!
      </template>

      <form @submit.prevent class="max-w-658p m-auto">
        <div
          class="user-input-wrp w-full relative"
          data-aos="fade-up"
          data-aos-easing="linear"
          data-aos-duration="500"
        >
          <br/>
          <input
            v-model="form.fullName"
            type="text"
            class="inputText outline-none border border-gray-500 py-2 px-3 w-full rounded-tl-2xl rounded-r-2xl"
            required
          />
          <span class="floating-label text-16 text-navy/016">Full Name</span>
        </div>

        <div
          class="user-input-wrp w-full relative"
          data-aos="fade-up"
          data-aos-easing="linear"
          data-aos-duration="500"
        >
          <br/>
          <input
            v-model="form.email"
            type="text"
            class="inputText outline-none border border-gray-500 py-2 px-3 w-full rounded-tl-2xl rounded-r-2xl"
            :class="{'emailError': emailValidate}"
            required
          />
          <span
            class="floating-label text-16 text-navy/016"
            :class="{'emailError': emailValidate}"
          >
            Contact Email
          </span>
        </div>

        <div
          class="user-input-wrp w-full relative"
          data-aos="fade-up"
          data-aos-easing="linear"
          data-aos-duration="500"
        >
          <br/>
          <input
            v-model="form.subject"
            type="text"
            class="inputText outline-none border border-gray-500 py-2 px-3 w-full rounded-tl-2xl rounded-r-2xl"
            required
          />
          <span class="floating-label text-16 text-navy/016">Subject</span>
        </div>

        <div
          class="user-input-wrp w-full relative"
          data-aos="fade-up"
          data-aos-easing="linear"
          data-aos-duration="500"
        >
          <br/>
          <textarea
            v-model="form.message"
            type="text"
            class="inputText outline-none border border-gray-500 rounded-tl-2xl rounded-r-2xl w-full py-2 px-3 resize-none h-150p"
            required
          />
          <span class="floating-label text-16 text-navy/016">Your Message</span>
        </div>


        <div
          class="h-180p mt-1 flex gap-2"
          data-aos="fade-up"
          data-aos-easing="linear"
          data-aos-duration="500"
          @dragover.prevent
          @drop.prevent="dragFile"
        >
          <label class="upload-area h-full w-full border border-dashed border-neutral/400 flex flex-col justify-center items-center cursor-pointer rounded-2xl">
            <input
              type="file"
              class="hidden"
              @change="uploadFile"
              :accept="fileAcceptedTypes.join(',')"
              multiple
            />
            <img src="@/assets/icons/file.svg" alt="">
            <span class="mt-2 text-16 text-blue_500">
              Select your file to upload
            </span>
            <span class="mt-2 text-14 text-neutral/500">
              or drag and drop it here
            </span>
          </label>
        </div>
        <!--        uploaded files-->
        <template v-if="fileValue.length">
          <div v-for="file in fileValue" :key="file.name" class="bg-neutral/400/01 mt-6 px-6 py-1.5 rounded-2xl flex gap-5">
            <img src="@/assets/icons/file_icon.svg" alt="">
            <div class="flex flex-col w-full">
              <span class="text-blue_500 text-14 font-medium">{{ file.name }}</span>

              <div class="w-full overflow-hidden rounded-2xl h-1 bg-neutral/400/02 mt-2 mb-1">
                <div class="bg-primary1 bg-yellow-100 h-full w-full"/>
              </div>

              <span class="text-12 text-neutral/500">{{ ((file.size/1024)/1024).toFixed(2) }}MB</span>
            </div>
            <div class="flex justify-center items-center">
              <img src="@/assets/icons/remove.svg" alt="Remove file" class="cursor-pointer" @click="removeUploadedFile(file.name)">
            </div>
          </div>
        </template>

        <div v-if="isSuccess" class="flex flex-col w-full items-center px-6 py-5">
          <div class="mb-6">
            <img src="@/assets/icons/success.svg" alt="" class="cursor-pointer" @click="removeUploadedFile(file.name)">
          </div>
          <p class="font-extrabold text-18">Your submission has been sent!</p>
        </div>

        <div class="flex items-center justify-center mt-14">
          <custom-button
            @buttonClick="submitHandler"
            :isDisabled="validator"
          >
            Send
          </custom-button>
        </div>

      </form>
    </section-layout>

      <div  id="map">
        <google-map/>
      </div>
  </div>
</template>

<script>
export default {
  name:  'ContactUs',
}
</script>

<script setup>
import ContactItem from '@/components/Contact_us/ContactItem'
import { ref, reactive, computed } from 'vue'
import { useContent } from '@/composables/useContent'
import SectionLayout from '@/layouts/SectionLayout'
import PageHero from '@/components/PageHero'
import CustomButton from "@/components/UI_components/CustomButton";
import GoogleMap from '@/components/Map/GoogleMap.vue';
const fileValue = reactive([])
const fileAcceptedTypes = ['.jpg', '.jpeg', '.pdf', '.doc', '.docx']
const uploadFile = (e) => {
  const files = Array.from(e.target.files);
  files.forEach(f =>  _checkFileTypeAndSizeAndAdd(f))
}
const dragFile = (e) => {
  const files = Array.from(e.dataTransfer.files)
  files.forEach(f => _checkFileTypeAndSizeAndAdd(f))
}
const removeUploadedFile = (fileName) => {
  const idx = fileValue.findIndex(item => item.name === fileName)
  fileValue.splice(idx, 1)
}
const _checkFileTypeAndSizeAndAdd = file => {
  const ifTypeAccepted = fileAcceptedTypes.find(type => file.type.includes(type.slice(1)))
  if (!ifTypeAccepted) return
  if (file.size !== 0 && file.size/1024/1024 <= 10) {
    fileValue.push(file)
  }
}
// Иконки и тип ссылки заданы здесь, тексты и адреса приходят из админки.
const contactIcons = {
  email: require('@/assets/icons/email_primary.svg'),
  location: require('@/assets/icons/location_primary.svg'),
  phone: require('@/assets/icons/phone_primary.svg'),
}

const contactHref = (type, value) => {
  const text = String(value ?? '')

  if (type === 'email') return `mailto:${text}`
  if (type === 'phone') return `tel:${text.replace(/[^+\d]/g, '')}`

  return '#map'
}

const defaultContacts = [
  { info_type: 'email', title: 'Email Us', info: 'hr@dthreads.am', description: 'Our support team will get back to you within 48 hours during standard business hours.' },
  { info_type: 'location', title: 'Find Us', info: 'Abelyan Street, 6/4, Yerevan, Armenia', description: 'Drop by for a visit, we are here from Mon-Fri, 09:00 to 18:00' },
  { info_type: 'phone', title: 'Call Us', info: process.env.VUE_APP_SITE_CONTACT_US_PHONE_NUMBER, description: 'Our support team will get back to you within 48 hours during standard business hours.' },
]

const { items: emailInfo } = useContent('contactEmail', [defaultContacts[0]])
const { items: locationInfo } = useContent('contactLocation', [defaultContacts[1]])
const { items: phoneInfo } = useContent('contactPhone', [defaultContacts[2]])

const contacts = computed(() => [
  { type: 'email', data: emailInfo.value[0] ?? defaultContacts[0] },
  { type: 'location', data: locationInfo.value[0] ?? defaultContacts[1] },
  { type: 'phone', data: phoneInfo.value[0] ?? defaultContacts[2] },
].map(({ type, data }) => ({
  type,
  icon: contactIcons[type],
  title: data.title,
  href: contactHref(type, data.info),
  info: data.info,
  description: data.description,
})))
const initialForm = {
  fullName: '',
  email: '',
  subject: '',
  message: '',
  filesId: null
}
const isSuccess = ref(false)
const form = reactive({ ...initialForm })
const sending = ref(false)
const emailValidate = computed(() => form.email !== '' && !/^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(form.email))
const validator = computed(() => {
  return (form.fullName === '' || form.email === '' || form.subject === '' || form.message === '' || emailValidate.value || sending.value)
})
const submitHandler = async() => {
  sending.value = true
  if (fileValue.length) {
    try {
      const filesId = await addFiles(fileValue)
      form.hasFile = true
      const contactId = await addContact(form, filesId)
    } catch (e) {
      console.error(e)
    }
  } else {
    const contactId = await addContact(form)
  }
  sending.value = false
  Object.assign(form, initialForm)
  fileValue.splice(0)
}
const addContact = async (data, filesId) => {
  try {
    const baseURL = `${process.env.VUE_APP_BACK_END_API_BASE_URL}/contact/send`
    data.filesId = filesId
    const response = await fetch(baseURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    const res = await response.json()
    if (res.id) isSuccess.value = true

    return res.id
  } catch (e) {
    console.error(e)
  }
}
const addFiles = async files => {
  const ids = []
  const response = files.map(async file => await addFile(file))
  for await (const id of response) {
    if (id) {
      ids.push(id)
    }
  }
  return ids
}
const addFile = async file => {
  try {
    const baseURL = `${process.env.VUE_APP_BACK_END_API_BASE_URL}/file/upload`
    const data = new FormData()
    data.append('file', file)
    const response = await fetch(baseURL, {
      method: 'POST',
      body: data
    })
    const id = await response.json()
    return id.id
  } catch (e) {
    console.error(e)
  }
}

// Заголовок страницы и текст блока «свяжитесь с нами» редактируются в админке
const { items: pageData } = useContent('contactPage', [])
const page = computed(() => pageData.value[0] ?? {})

</script>

<style scoped>
/* outline-none убрал системную подсветку фокуса и ничем её не заменил:
   не было видно, какое поле активно, и клавиатурная навигация вслепую */
.inputText {
  transition: border-color .2s ease, box-shadow .2s ease;
}

.inputText:hover {
  border-color: #041729;
}

.inputText:focus {
  border-color: #FFCE1F;
  box-shadow: 0 0 0 3px rgba(255, 206, 31, .25);
}

.inputText.emailError:focus {
  border-color: red;
  box-shadow: 0 0 0 3px rgba(255, 0, 0, .2);
}

.upload-area {
  transition: border-color .2s ease, background-color .2s ease;
}

.upload-area:hover,
.upload-area:focus-within {
  border-color: #FFCE1F;
  background-color: rgba(255, 206, 31, .06);
}

@media (prefers-reduced-motion: reduce) {
  .inputText,
  .upload-area {
    transition: none;
  }
}

.user-input-wrp .floating-label {
  position: absolute;
  pointer-events: none;
  top: 33px;
  left: 10px;
  transition: 0.2s ease all;
}
.user-input-wrp input:focus ~ .floating-label,
.user-input-wrp textarea:focus ~ .floating-label,
.user-input-wrp input:not(:focus):valid ~ .floating-label,
.user-input-wrp textarea:not(:focus):valid ~ .floating-label{
  top: 4px;
  font-size: 13px;
  opacity: 1;
}
.bg-contact-us {
  background-image: url('~@/assets/backgrounds/contact-us-background.png');
}
.emailError {
  border-color: red;
  color: red;
}
</style>